import React, { useState } from "react";
import { Button } from "@mui/material";
import { Lock as LockIcon, Delete as DeleteIcon } from "@mui/icons-material";
import rootStyles from "../styles.module.scss";
import { ChangePassword } from "./ChangePassword";
import { TwoFactorProcess } from "./TwoFactorProcess";
import { PinProcess } from "./PinProcess";

export const SecurityPage: React.FC = () => {
	return (
		<div className={rootStyles.contentWrapper}>
			{/* Security Section */}
			<section className={rootStyles.section}>
				<div className={rootStyles.sectionHeader}>
					<LockIcon className={rootStyles.icon} />
					<div className={rootStyles.titles}>
						<h3>Segurança e Login</h3>
						<p>Gerencie sua senha e métodos de autenticação.</p>
					</div>
				</div>

				{/* Change Password Card */}
				<ChangePassword />

				{/* 2FA Card */}
				<TwoFactorProcess />

				{/* PIN Card */}
				<PinProcess />
			</section>

			{/* Danger Zone (Mockup requirement: "tela de Segurança") */}
			<section className={rootStyles.section}>
				<div className={`${rootStyles.card} ${rootStyles.dangerZone}`}>
					<h4>
						<DeleteIcon fontSize="small" /> Zona de Perigo
					</h4>
					<p style={{ fontSize: "0.875rem", color: "var(--mui-palette-text-secondary)", margin: "0" }}>
						Ações irreversíveis. Prossiga com cuidado.
					</p>

					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							borderTop: "1px solid rgba(233, 20, 41, 0.1)",
							paddingTop: "1rem",
						}}
					>
						<div>
							<h5 style={{ margin: 0, fontWeight: 600, fontSize: "0.875rem" }}>Deletar Conta</h5>
							<p style={{ margin: 0, fontSize: "0.75rem", color: "var(--mui-palette-text-secondary)" }}>
								Isso irá apagar permanentemente seus dados
							</p>
						</div>
						<Button
							variant="outlined"
							color="error"
							size="small"
							disabled
						>
							Deletar Conta
						</Button>
					</div>
				</div>
			</section>
		</div>
	);
};
